import { render, staticRenderFns } from "./RecruitmentDriveTest.vue?vue&type=template&id=1b25fc2e"
import script from "./RecruitmentDriveTest.vue?vue&type=script&lang=js"
export * from "./RecruitmentDriveTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports